import {
    IUnorderedVerticalListItem,
    IUnorderedVerticalListProperties,
    UnorderedVerticalList,
} from '@vfde-brix/ws10/unordered-vertical-list';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { decodeHtml } from '@vfde-sails/utils';
import { getCMSTariffBenefits } from '../cms';
import { CmsTariffBenefitForTariffs } from '../../interface';
import { replaceTariffPlaceholders } from '../formatter';
import { JarvisProduct } from '@vfde-sails/availability';

const getBenefitItem = (tariff: JarvisProduct) => (benefit: CmsTariffBenefitForTariffs): IUnorderedVerticalListItem => ({
    business: NO_PATTERN_BUSINESS_LOGIC,
    stdHeadline: decodeHtml(benefit.headline),
    txtText: benefit.subline && replaceTariffPlaceholders(benefit.subline, tariff),
    stdIcon: benefit.iconName,
    optSize: 'default',
});

const formatBenefitPlaceholders = (props: IUnorderedVerticalListProperties, tariff: JarvisProduct) => {
    for (const item of props.listUnorderedVerticalListItems) {
        if (!item.txtText?.includes('$')) {
            continue;
        }

        item.txtText = replaceTariffPlaceholders(item.txtText, tariff);
    }
};

/**
 * Gets properties for benefit list
 */
export const getTariffBenefitsUpdatedProps = (
    verticalList: UnorderedVerticalList | null,
    tariff: JarvisProduct,
): Partial<IUnorderedVerticalListProperties> => {
    const cmsBenefits = getCMSTariffBenefits(tariff.id);

    if (!verticalList || !cmsBenefits.length) {
        return { listUnorderedVerticalListItems: [] };
    }

    const props = verticalList.getProperties();

    props.listUnorderedVerticalListItems = cmsBenefits.map(getBenefitItem(tariff));

    formatBenefitPlaceholders(props, tariff);

    return props;
};
